import { type ReactNode } from 'react'
import { Button, Tooltip } from 'antd'

export function ToolbarButton({
  active = false,
  disabled = false,
  icon,
  label,
  onClick
}: {
  active?: boolean
  disabled?: boolean
  icon: ReactNode
  label: string
  onClick: () => void
}) {
  return (
    <Tooltip title={label}>
      <Button
        aria-label={label}
        aria-pressed={active}
        className={active ? '!text-accent !bg-[var(--accent-soft)]' : ''}
        disabled={disabled}
        icon={icon}
        onClick={onClick}
        onMouseDown={(event) => event.preventDefault()}
        size="small"
        type="text"
      />
    </Tooltip>
  )
}

export function ToolbarDivider() {
  return <span aria-hidden className="bg-border mx-1 h-5 w-[0.0625rem] shrink-0" />
}
